import { NgModule } from '@angular/core';
import { UniqueSnapaddrsValidator } from './unique-snapaddrs.validator';

@NgModule({
    imports: [UniqueSnapaddrsValidator],
    exports: [UniqueSnapaddrsValidator],
})
export class UniqueSnapaddrsValidatorModule {}
